/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import React from 'react';

import {useTranslation} from 'react-i18next';

import BluemateStatusTile, {StatusTileState} from './bluemateStatusTile';

interface Props {
    state?: StatusTileState;
    onClick?: () => void;
    className?: string;
}

export default function BluemateAutoEmailStatus(props: Props) {
    const {state = 'green', onClick, className} = props;
    const {t} = useTranslation();

    // Never red: leaving auto e-mailing off is a preference, not a fault.
    const labels: Record<StatusTileState, string> = {
        green: t('controls.statusTile.autoEmail.green', 'Auto e-mailen'),
        gray: t('controls.statusTile.autoEmail.gray', 'Auto e-mailen uit'),
        orange: t('controls.statusTile.autoEmail.orange', 'Auto e-mailing gepauzeerd'),
        red: t('controls.statusTile.autoEmail.red', 'Auto e-mailing uit')
    };

    return <BluemateStatusTile className={className} label={labels[state]} state={state} onClick={onClick} />;
}
